import * as React from 'react';

import Typography from '@components/basics/typography';
import DashboardContainer from '@components/layout/dashboard-container';
import Dos from '@components/statics/merch-term-condition';

interface DistributionAgreementProps {
  className?: string;
}

const TermConditions: React.FC<DistributionAgreementProps> = (props) => (
  <DashboardContainer className={props.className}>
    <Typography className="mb-30" type="subheader" weight="700">
      Merchandise Agreement
    </Typography>
    <Dos />
  </DashboardContainer>
);

export default TermConditions;
